import { Box, Flex, Heading, Text, Button, Image, useColorModeValue } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import logoCidadeInteligente from '../../assets/svg/logo.svg';

const MotionFlex = motion(Flex);
const MotionBox = motion(Box);

export const PaginaNaoEncontrada = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("blue.600", "blue.900");

  return (
    <Flex
      width="100vw"
      height="100vh"
      bg={bgColor}
      align="center"
      justify="center"
      position="relative"
      overflow="hidden"
    >
      <MotionBox
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundPosition="center"
        animate={{ filter: ["brightness(0.8)", "brightness(1)", "brightness(0.8)"] }}
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
      />

      <MotionFlex
        direction="column"
        align="center"
        justify="center"
        zIndex={2}
        p={4}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Image
          src={logoCidadeInteligente}
          alt="Logo do App - CIDADE Inteligente"
          mb={4}
          width={{ base: "150px", md: "200px" }}
          objectFit="contain"
        />
        <Heading
          fontSize={{ base: "6xl", md: "8xl" }}
          color="white"
          textShadow="2px 2px 4px rgba(0,0,0,0.6)"
        >
          404
        </Heading>
        <Text
          mt={4}
          fontSize={{ base: "xl", md: "2xl" }}
          color="white"
          textAlign="center"
          maxW="600px"
          textShadow="1px 1px 3px rgba(0,0,0,0.6)"
        >
          Ops! A página que você procura não foi encontrada.
        </Text>
        <Button
          mt={8}
          size="lg"
          variant="outline"
          borderColor="whiteAlpha.900"
          color="white"
          _hover={{ bg: "whiteAlpha.200" }}
          onClick={() => navigate('/cms/inicio')}
        >
          Voltar para a Página Inicial
        </Button>

      </MotionFlex>
    </Flex>
  );
};

export default PaginaNaoEncontrada;
